import React, { useEffect, useRef, useState } from 'react';
import InfiniteSlider from '../../DnDInfiniteSlider/InfiniteSlider';
import { ChildComponents } from '../../DnDChildComponents';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';

function CarouselBannerBase({ item, imageWidth, aspectRatio, activeBigger, isCentered }) {
  const images = item?.data?.images || [];
  const [reset, forceReset] = useState(false);
  const min = item?.variantData?.minImage;
  const customization = staticComponentValueConverter(item?.customization);
  const imageHashMap = useSelector(state => state.themeSlice?.imageHashMap);

  useEffect(() => {
    forceReset(state => !state);
  }, [item?.customization?.containerPadding, images?.length]);

  const slideDirection = customization?.autoSlideDirection;
  const _slideSpeed = customization?.autoSlideInterval;
  const activeIndicator = ChildComponents[customization?.indicator]?.component;

  const renderImages = images.map((imgObj, index) => (
    <React.Fragment key={index}>
      <div className="flex flex-col relative  min-w-full">
        <div
          className=" relative min-w-full"
          style={{
            padding: `${customization?.padding}`,
          }}
        >
          <div>
            {imgObj?.image?.type === 'video' ? (
              <video
                style={{
                  aspectRatio: aspectRatio,
                  objectFit: customization?.backgroundSize,
                  borderRadius: customization?.borderRadius,
                  boxShadow: ChildComponents[customization?.boxShadow]?.data,
                }}
                autoPlay
                muted
                playsInline
                loop
                src={imgObj?.image?.src}
              ></video>
            ) : (
              <img
                className="w-full"
                src={imgObj?.useCustomImage ? imgObj?.image?.src : imageHashMap[imgObj?.id]?.image}
                style={{
                  aspectRatio: aspectRatio,
                  objectFit: customization?.backgroundSize,
                  borderRadius: customization?.borderRadius,
                  boxShadow: ChildComponents[customization?.boxShadow]?.data,
                }}
              />
            )}
          </div>
          {customization?.isShowProductTitle && (
            <div
              className="line-clamp-2"
              style={{
                paddingTop: 2,
                fontWeight: customization?.productTextWeight,
                fontStyle: customization?.productTextStyle,
                fontSize: customization?.productTextSize,
                color: customization?.productTextColor,
              }}
            >
              {imgObj?.image?.text}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  ));

  return (
    <>
      {images?.length >= min ? (
        <div
          className="`overflow-x-visible relative"
          style={{
            padding: `${customization?.containerPadding}`,
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div className={`collection-slider relative `}>
            <div
              style={{
                fontWeight: customization?.textWeight,
                fontStyle: customization?.textStyle,
                fontSize: customization?.textSize,
                color: customization?.textColor,
                textAlign: customization?.textAlignment,
                letterSpacing: customization?.textLetterSpacing,
              }}
            >
              {item?.data?.text}
            </div>
            <div className="relative collection--slider flex flex-col">
              <InfiniteSlider
                activeAnimationCoefficient={1}
                pausedAnimationCoefficient={1}
                forceReset={reset}
                sliderId={item?.id}
                isCentered={isCentered}
                activeBigger={activeBigger}
                indicator={activeIndicator}
                activeIndicatorColor={item?.customization?.activeIndicatorColor}
                inactiveIndicator={item?.customization?.inactiveIndicator}
                // customization?.indicatorColor
                classNames={{
                  SliderItemWrapper: 'image-wrapper pr-[1%] flex flex-col min-w-full',
                }}
                styles={{
                  SliderItemWrapper: {
                    display: 'flex',
                    minWidth: (imageWidth || item?.customization?.imageWidth || 100) + '%',
                    maxWidth: (imageWidth || item?.customization?.imageWidth || 100) + '%',
                    height: 'auto',
                    wordSpacing: `${customization?.textWordSpacing}px`,
                    letterSpacing: `${customization?.textLetterSpacing}px`,
                  },
                }}
              >
                {renderImages}
              </InfiniteSlider>
              {customization?.isShowArrows === 'show' && (
                <div
                  className={`absolute left-0 w-full flex justify-between`}
                  style={{
                    width: 40,
                    height: 40,
                    marginLeft: customization?.distanceToTheCorner,
                    top: `${customization?.distanceToTop}%`,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: customization?.carouselArrowsBackgroundColorBorderRadius,
                      border: '1px',
                      borderStyle: 'solid',
                      borderColor:
                        customization?.isShowBackground === 'show'
                          ? customization?.carouselArrowsBorderColor
                          : 'transparent',
                      backgroundColor:
                        customization?.isShowBackground === 'show'
                          ? customization?.carouselArrowsBackgroundColor
                          : 'transparent',
                      width: 40,
                      height: 40,
                    }}
                  >
                    <svg
                      width={customization?.carouselArrowSize}
                      height={customization?.carouselArrowSize}
                      viewBox="0 0 0.6 0.6"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.36 0.48a0.03 0.03 0 0 1 -0.021 -0.009l-0.15 -0.15a0.03 0.03 0 0 1 0 -0.042l0.15 -0.15a0.03 0.03 0 1 1 0.042 0.042L0.252 0.3l0.129 0.129A0.03 0.03 0 0 1 0.36 0.48"
                        fill={customization?.carouselArrowsColor}
                      />
                    </svg>
                  </div>
                </div>
              )}
              {customization?.isShowArrows === 'show' && (
                <div
                  className={`absolute  right-0 w-full flex justify-between`}
                  style={{
                    width: 40,
                    height: 40,
                    marginRight: customization?.distanceToTheCorner,
                    top: `${customization?.distanceToTop}%`,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: customization?.carouselArrowsBackgroundColorBorderRadius,
                      border: '1px',
                      borderStyle: 'solid',
                      borderColor:
                        customization?.isShowBackground === 'show'
                          ? customization?.carouselArrowsBorderColor
                          : 'transparent',
                      backgroundColor:
                        customization?.isShowBackground === 'show'
                          ? customization?.carouselArrowsBackgroundColor
                          : 'transparent',
                      width: 40,
                      height: 40,
                    }}
                  >
                    <svg
                      width={customization?.carouselArrowSize}
                      height={customization?.carouselArrowSize}
                      viewBox="0 0 0.6 0.6"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.24 0.48a0.03 0.03 0 0 1 -0.021 -0.051L0.348 0.3 0.219 0.171a0.03 0.03 0 1 1 0.042 -0.042l0.15 0.15a0.03 0.03 0 0 1 0 0.042l-0.15 0.15A0.03 0.03 0 0 1 0.24 0.48"
                        fill={customization?.carouselArrowsColor}
                      />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
}

export default CarouselBannerBase;
